import { Component, inject } from '@angular/core';
import { AuthSessionService } from '../../auth-session.service';

@Component({
  imports: [],
  selector: 'app-attire',
  styleUrl: './attire.scss',
  templateUrl: './attire.html',
})
export class Attire {
  readonly version = inject(AuthSessionService).paxVersion;
}
